import { t } from "../i18n";
import { Dialog } from "./Dialog";

interface Props {
  /** The question, e.g. '"Margherita" verwijderen uit het menu? Oude bestellingen blijven bewaard.' */
  message: string;
  /** The word on the confirm button, e.g. "Verwijderen". */
  confirm: string;
  /** Red for what cannot be undone (the default), or the normal main button. */
  tone?: "danger" | "primary";
  onConfirm: () => void;
  onClose: () => void;
}

/** The confirmation window of the prototype (confirmBox): the question, [Annuleren] [confirm]. */
export function ConfirmDialog({ message, confirm, tone = "danger", onConfirm, onClose }: Props) {
  return (
    <Dialog
      title={t.confirm.title}
      size="narrow"
      onClose={onClose}
      footer={
        <>
          <span className="spacer" />
          <button type="button" className="btn" onClick={onClose}>
            {t.confirm.cancel}
          </button>
          <button
            type="button"
            className={`btn ${tone}`}
            data-autofocus
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirm}
          </button>
        </>
      }
    >
      <p className="confirm-text">{message}</p>
    </Dialog>
  );
}
